import "../../App.css";
const Spinner=()=>{
  return(
    <div className="text-white spinner"></div>
  )
}

export default Spinner